import 'select2';

// $.fn.select2.defaults.set('language', 'fr');

export default function() {
    $('select').select2({
        // placeholder: 'Vous êtes',
        dropdownAutoWidth : true,
        minimumResultsForSearch: Infinity,
    });
    
    $('b[role="presentation"]').hide();
    $('.select2-selection__arrow').append('<svg><use xlink:href="#icon-arrow-right"></use></svg>');

    $('.c-newsletter-form select[name="persona"]').on('select2:select', function (e) {
        var data = e.params.data;
        $('.c-newsletter-form form').attr('action', data.id);
      });
}
